import { render, staticRenderFns } from "./doHandlezzb.vue?vue&type=template&id=a497b654&"
import script from "./doHandlezzb.vue?vue&type=script&lang=js&"
export * from "./doHandlezzb.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports